import React from 'react'
import { Navbar } from '../../@shared/navigations/default';

const AboutPage = () => {
    return (
        <React.Fragment>
            <Navbar />
            <div id="about">
                <div className="banner"></div>
                <div className="page">
                    <h1 className='title'>About</h1>
                    <div className="body">
                        <p> Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti eligendi quos, natus, voluptatibus aliquid nisi, qui laboriosam harum sapiente repudiandae nobis deserunt. Aut sequi quae tempora reprehenderit suscipit labore quasi.
                        Magni corporis sunt dolor earum qui, velit fugiat nostrum illum quia beatae quod labore nobis ipsa rerum cum eveniet ducimus blanditiis deserunt odit voluptatibus sed voluptas eaque. Libero, et cum? </p>
                        <br />
                        <i> Asperiores ipsam corporis, blanditiis voluptas debitis odit fugiat cumque consectetur excepturi tempora inventore nobis alias eos dignissimos porro qui iste quo quod! Quam mollitia est nostrum necessitatibus unde, facilis vel?</i>
                    </div>
                <hr />
                    <ul>
                        <li><a href="/about">About us</a></li>
                    </ul>
                </div>
                <div className="sub-page">
                    <h1 className='title'>Our Story</h1>
                    <i>Unde quisquam commodi, saepe porro voluptatibus molestiae repellendus, dolore eum consectetur deleniti praesentium, inventore ullam modi quam quas. </i>
                    <div className='flex descriptions'>
                        <p className='side'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Suscipit earum nulla exercitationem temporibus blanditiis porro dolorem, harum obcaecati, magnam similique minima sed ut veritatis, unde dicta voluptatibus autem optio distinctio.</p>
                        <p className='side'>Eligendi perspiciatis, reiciendis sequi. Quos, aut! Aut labore veritatis magnam dicta quibusdam, temporibus eos impedit quam cum pariatur reprehenderit culpa nobis dolore rem error exercitationem voluptatem, repellat assumenda saepe consequatur.</p>
                    </div>
                    <div className='center reward'>
                        <img src="/assets/images/assets/reward.png" alt="reward" width="60" />
                        <h3 className='title'>Best facts about company</h3>
                        <p> Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima suscipit eius adipisci aut quo vitae, totam atque iure, ipsam qui recusandae. Amet eos quia rem laboriosam voluptate itaque voluptatem fugiat. </p>
                    </div>
                    <ul>
                        <li> <h4 className='count'>+7500</h4> <p>HAPPY CUSTOMER</p> </li>
                        <li> <h4 className='count'>+900</h4> <p>SATISFIED CLIENTS</p> </li>
                        <li> <h4 className='count'>+17000</h4> <p>HOURS OF WORK</p> </li>
                        <li> <h4 className='count'>+3325</h4> <p>PROJECTS DELIVERED</p> </li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AboutPage;